import {
    ChangeDetectionStrategy,
    Component,
    input,
    InputSignal,
    OnChanges,
    output,
    signal,
    SimpleChanges,
    WritableSignal
} from "@angular/core";
import {
    CreatedFromOtherItemReview,
    FinishedQuestionReview,
    PostQuestionReview,
    Review,
    SendKudosReview
} from "../../taskbook-triage/taskbook.types";
import { UserInfos } from "../../shared/ui/username-icon/user-infos.type";
import { ThreadAuthor } from "@teammood/timeline";
import { ManagerCommentUpdate } from "../manager-comment-review/manager-comment-review.component";
import { takeUntil } from "rxjs";
import { TaskBookBacklogDialogService } from "../taskbook-backlog-dialog.service";
import { ITeam } from "@teammood/team";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'review-history-element',
    templateUrl: './review-history-element.component.html',
    styleUrls: ['./review-history-element.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReviewHistoryElementComponent implements OnChanges {

    reviewer: WritableSignal<string> = signal(''); // format with first en last names todo

    review: InputSignal<Review> = input<Review>();
    userId: InputSignal<string> = input<string>();
    teams: InputSignal<ITeam[]> = input<ITeam[]>();
    commentAuthors: InputSignal<ThreadAuthor[]> = input<ThreadAuthor[]>();

    protected deleteReviewComment = output<Review>()

    protected editReviewComment = output<ManagerCommentUpdate>()

    constructor(
        private taskbookBacklogDialogService: TaskBookBacklogDialogService,
        protected translateService: TranslateService,
    ){}

    ngOnChanges(changes: SimpleChanges): void {
        this.review.apply(changes['review'].currentValue); //

        if (this.review().reviewer.id === this.userId()) {
            this.reviewer.set('');
        } else {
            this.reviewer.set(this.review().reviewer.fullname + ' ');
        }
    }

    protected userInfos(userId: string): UserInfos {
        const commentReviewer = this.commentAuthors().find(commentAuthor => commentAuthor.id === userId);
        return new UserInfos(commentReviewer.firstname, commentReviewer.lastname);
    }

    onReviewCommentDeleted(reviewComment: Review) {
        this.deleteReviewComment.emit(reviewComment);
    }

    onReviewCommentEdited(reviewComment: ManagerCommentUpdate) {
        this.editReviewComment.emit(reviewComment);
    }

    async openItemDialog(review: Review){
        switch(review.reviewType){
            case 'SendKudosReview':
                const kudosDialogRef = await this.taskbookBacklogDialogService.kudosTaskDetails((review as SendKudosReview).kudosId);
                kudosDialogRef.beforeClosed().pipe(
                    takeUntil(kudosDialogRef.afterClosed())
                ).subscribe();
                break;
            case 'PostQuestionReview':
                const pollDialogRef = await this.taskbookBacklogDialogService.pollTaskDetails((review as PostQuestionReview).questionId, this.teams(), 'backlog', 'preview');
                pollDialogRef.beforeClosed().pipe(
                    takeUntil(pollDialogRef.afterClosed())
                ).subscribe();
                break;
            case 'FinishedQuestionReview':
                const pollResultsDialogRef = await this.taskbookBacklogDialogService.pollTaskDetails((review as FinishedQuestionReview).questionId, this.teams(), 'backlog', 'results', (review as FinishedQuestionReview).occurrenceId);
                pollResultsDialogRef.beforeClosed().pipe(
                    takeUntil(pollResultsDialogRef.afterClosed())
                ).subscribe();
                break;
            // todo add other review types for question occurrence results
            // case 'OccurrenceResultReview':
            //     const pollDialogRef = await this.taskbookBacklogDialogService.pollTaskDetails(review.questionId, this.teams, 'backlog', 'results', review.occurrenceId);
            //     pollDialogRef.beforeClosed().pipe(
            //         takeUntil(pollDialogRef.afterClosed())
            //     ).subscribe();
            //     break;
            default:
                break;
        }
    }

    protected linkToOtherItem(review: Review) {
        return ['/backlog', (review as CreatedFromOtherItemReview).createdFromTimelineItemType, (review as CreatedFromOtherItemReview).createdFromTimelineItemId];

    }
}